import { defineStore } from "pinia";
import { timeSpToDate, getItem, setItem } from "@/utils/module.js";
import { STORE_NAME_SUBMIT_GROUP_CODE } from "@/utils/storeAgeTables";

// 当前本地状态默认数据
const currStateDefaults = () => ({
  // http axios的cancel source
  httpSource: null,

  // 自定义layout标题
  customLayOutTitle: "",

  // 当前window 的 innerWidth
  windowInnerWidth: 0,
  // 当前window 的 outerWidth
  windowOuterWidth: 0,

  // 记录页面的跳转之前的scrollTop
  recordRouteScrollbarTop: {},

  // 控制顶部header的显示
  showHeaderNavbar: true,
  // 控制底部foor的显示
  showDownFooter: true,
});

// 随机生成字母
const randCode = (length = 0, mode = "toLowerCase") => {
  let randStr = "";
  for (let i = 0; i < length; i++) {
    const random = Math.random() * 26 + "a".charCodeAt(0);
    randStr += String.fromCharCode(Math.floor(random));
  }

  return randStr[mode]();
};

export default defineStore({
  id: "main",
  state: () => currStateDefaults(),
  actions: {
    // 每次调用使用当天日期，随机字母从浏览器本地缓存复用
    getSubmitGroupNo: () => {
      let groupCode = getItem(STORE_NAME_SUBMIT_GROUP_CODE);
      if (!groupCode) {
        groupCode = randCode(6);
        setItem(STORE_NAME_SUBMIT_GROUP_CODE, groupCode);
      }

      const YMD = timeSpToDate(Date.now()).split("-").join("");
      return `${YMD}-${groupCode.toUpperCase()}`;
    },
  },
  getters: {
    getHttps: (state) => state.https,
    // 计算当前比例
  },
});
